import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const IN = 0.0254;

export function DormAirPurifierTowerSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const isSide = view === 'left' || view === 'right';
  const w = isSide ? depth : width;

  const topH = height * 0.15;
  const baseH = height * 0.06;
  const grilleBottom = baseH + 0.5 * IN;
  const grilleTop = baseH + (height - topH - baseH) * 0.85;
  const grilleRegionH = grilleTop - grilleBottom;
  const numBars = Math.max(4, Math.round(grilleRegionH / (1.2 * IN)));
  const barSpacing = grilleRegionH / numBars;
  const barInset = w * 0.08;

  const bars = [];
  for (let i = 0; i < numBars; i++) {
    const y = height - grilleBottom - barSpacing * (i + 0.5);
    bars.push(
      <Line
        key={`bar-${i}`}
        x1={barInset}
        y1={y}
        x2={w - barInset}
        y2={y}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.6}
      />
    );
  }

  return (
    <SchematicShell
      width={w}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {/* Top panel divider */}
      <Line
        x1={0}
        y1={topH}
        x2={w}
        y2={topH}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Base divider */}
      <Line
        x1={0}
        y1={height - baseH}
        x2={w}
        y2={height - baseH}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {bars}
    </SchematicShell>
  );
}

DormAirPurifierTowerSchematic.supportsSideViews = true;

export function DormAirPurifierCompactSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const isSide = view === 'left' || view === 'right';
  const w = isSide ? depth : width;

  const topCapH = height * 0.08;
  const lowerH = height * 0.5;
  const ventRegionH = lowerH * 0.85;
  const ventBottom = lowerH * 0.1;
  const numVents = Math.max(4, Math.round(ventRegionH / (0.8 * IN)));
  const ventSpacing = ventRegionH / numVents;
  const ventInset = w * 0.05;

  const vents = [];
  for (let i = 0; i < numVents; i++) {
    const y = height - ventBottom - ventSpacing * (i + 0.5);
    vents.push(
      <Line
        key={`vent-${i}`}
        x1={ventInset}
        y1={y}
        x2={w - ventInset}
        y2={y}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth * 0.5}
      />
    );
  }

  return (
    <SchematicShell
      width={w}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {/* Top cap divider */}
      <Line
        x1={0}
        y1={topCapH}
        x2={w}
        y2={topCapH}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Upper/lower body divider */}
      <Line
        x1={0}
        y1={height - lowerH}
        x2={w}
        y2={height - lowerH}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {vents}
    </SchematicShell>
  );
}

DormAirPurifierCompactSchematic.supportsSideViews = true;
